import { FormFactoryElement } from '../types/element.types';
import { FormFactoryField } from '../types/field.types';

export function isFormField<T extends FormFactoryElement & Record<string, unknown>>(model: T): model is FormFactoryField<T> {
	return typeof model.name === 'string';
}
